
  function initTestimonials20() {
      document.querySelector('.pc-testimonials-slider-template--24774097568082__pc_social_review_5_texPP7').classList.remove('preview');
      new Swiper(".pc-testimonials-slider-template--24774097568082__pc_social_review_5_texPP7", {
          speed: 1100,
          
          loop: true,
          
          
          navigation: {
              nextEl: '.pc-testimonials-btn-next-template--24774097568082__pc_social_review_5_texPP7',
              prevEl: '.pc-testimonials-btn-prev-template--24774097568082__pc_social_review_5_texPP7',
          },
          pagination: {
              el: '.pc-testimonials-pagination-template--24774097568082__pc_social_review_5_texPP7',
              type: "bullets",
              clickable: true
          },
          breakpoints: {
              320: {
                  spaceBetween: 24,
                  slidesPerView: 1.3,
              },
              768: {
                  spaceBetween: 24,
                  slidesPerView: 1.5,
              },
              1024: {
                  spaceBetween: 32,
                  slidesPerView: 3,
              }
          }
      });
  }

  document.addEventListener('DOMContentLoaded', initTestimonials20);
